import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import { RootState, TypedDispatch } from 'ReduxStore'

export const useAppDispatch = (): TypedDispatch => useDispatch<TypedDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
